export default {
  "content": "<path clip-rule=\"evenodd\" d=\"M2 2a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2zm1.088 1.691A1 1 0 001.912 5.31l5.5 4a1 1 0 001.176 0l5.5-4a1 1 0 00-1.176-1.618L8 7.264z\" fill=\"#ff00cb\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};